
import React, { useEffect, useState, useRef, useContext, forwardRef } from 'react'
import { Link } from 'react-router-dom'

/* PRIME REACT */
import { Paginator } from 'primereact/paginator';

/* COMPONENTES */
import SweetButton from '../../components/SweetButton';

/* UTILITÁRIOS */
import SingMask from '../../utils/SingMask';

import { AuthContext } from '../../Contexts/Auth/AuthContext'
import { ContentContext } from '../../Contexts/Contents/Context.js'
import { ExportXLS } from '../../services/class/exportXls.js'
//import "jspdf-autotable";
//import jsPDF from "jspdf";

/* ESTILOS CSS */
import 'primereact/resources/themes/lara-light-purple/theme.css';
import useCase from './useCase.js';
import { CircleSpinnerOverlay } from 'react-spinner-overlay'
import ShowToast from '../../components/Toast.jsx';
import { usePaginator } from '../../utils/Paginator.js'

const FragmentList = forwardRef((props, ref) => {
    const btnDelete = useRef();
    const containerRef = useRef(null);
    const { getTotalRecords } = usePaginator()
    const { getResult, isLoading, onResume, first, rows, template1, handlerDelete, broadCast, reloadList, onPageChange } = useCase();

    const { setAuth, auth, provider_session, provider_current_client } = useContext(AuthContext)
    const { listData, getBroadcast } = useContext(ContentContext)
    const [isShow_paginator, setShow_paginator] = useState(true);
    const [isCheckedAll, setCheckedAll] = useState(true);
    const [isReady, setIsReady] = useState(false);

    const [isDisabledButtonDeleteGroup, setIsDisabledButtonDeleteGroup] = useState(true);

    /* teste */
    const [checkboxValues, setCheckboxValues] = useState([]);

    const handleCheckboxChange = (event) => {
        const { checked, value } = event.target;
        if (checked)
            setCheckboxValues(prev => [...prev, value]);
        else
            setCheckboxValues(prev => prev.filter(item => item !== value));
    };

    const handleCheckAll = (e) => {
        setCheckboxValues([])
        const checkboxes = containerRef.current.querySelectorAll('.form-check-input');
        checkboxes.forEach(checkbox => {
            if (isCheckedAll == true)
                setCheckboxValues(prev => [...prev, checkbox.value]);
        });
    };

    useEffect(() => {
        if (btnDelete.current != undefined) {
            let RES = checkboxValues.length > 0 ? false : true
            setIsDisabledButtonDeleteGroup(RES)
        }

    }, [checkboxValues])

    useEffect(() => {
        if (getBroadcast != null)
            if (getBroadcast.command == "resetButtonDeleteGroup")
                setIsDisabledButtonDeleteGroup(true)
    }, [getBroadcast])

    useEffect(() => {
        reloadList(null);
    }, [])

    useEffect(() => {
        if (isLoading == false && isReady == false)
            setIsReady(true)
    }, [isLoading])

    useEffect(() => {
        console.clear();
        console.log('%c~ * ~ FRAGMENTLIST :: getResult foi atualizado ~ * ~', 'color: white; background-color: pink; padding: 4px;font-size: 18px');
        console.log("listData", listData);
        setCheckboxValues([])
    }, [listData])
    return (
        <>

            {
                isLoading &&
                <CircleSpinnerOverlay
                    loading={true}
                    zIndex="9999"
                    message="Carregando..."
                    overlayColor="rgba(0,153,255,0.5)"
                />
            }
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title mb-0">Listagem de Turmas</h4>
                        </div>
                        {/* end card header */}
                        {isReady == false ?
                            <div className="d-flex justify-content-center">
                                <button className="btn btn-primary rounded-pill waves-effect waves-themed" type="button" disabled="">
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span> &nbsp;Carregando...
                                </button>
                            </div> : (
                                <div className="card-body">
                                    <div className="listjs-table" id="customerList">
                                        <div className="row g-4 mb-3">
                                            <div className="col-sm-auto">
                                                <div className="list-grid-nav hstack gap-1">
                                                    <button type="button" className="btn btn-success add-btn" onClick={broadCast} id="create-btn" data-bs-toggle="modal" data-bs-target="#exampleModalgrid"><i className="ri-add-line align-bottom me-1"></i> Novo</button>
                                                    {<SweetButton
                                                        props={{
                                                            button: {
                                                                disabled: isDisabledButtonDeleteGroup,
                                                                ref: btnDelete,
                                                                className: "btn btn-soft-danger",
                                                                icon: "ri-delete-bin-2-line",
                                                                text: ""
                                                            },
                                                            swlConfig: {
                                                                type: "dialog",
                                                                icon: "question",
                                                                title: "Deseja excluir os registros selecionados?",
                                                                text: "",
                                                                confirmButtonText: "Sim, estou ciente.",
                                                                confirmButtonColor: '#d33', // Altere para a cor desejada em hexadecimal
                                                            },
                                                            actions: {
                                                                IfConfirmed: () => handlerDelete(checkboxValues), // Passar como uma função
                                                                IfDenied: ""
                                                            }
                                                        }} />
                                                    }

                                                    <button className="btn btn-soft-danger" onClick={() => new ExportXLS().generate({ template: "Turmas", type: "xls", body_content: getResult, outPutFilename: "Turmas - total" })}><i className="ri-printer-line"></i></button>
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="d-flex justify-content-sm-end">
                                                    <div className="search-box ms-2">
                                                        <input type="text" className="form-control search"
                                                            placeholder="Procurar..." />
                                                        <i className="ri-search-line search-icon"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="table-responsive table-card mt-3 mb-1">
                                            <table className="table align-middle table-nowrap" id="customerTable">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th scope="col" style={{ width: '50px' }}>
                                                            <div className="form-check">
                                                                <input className="form-check-input" onChange={(e) => handleCheckAll(setCheckedAll(prev => !prev))} type="checkbox"
                                                                    id="checkAll" value="option" />
                                                            </div>
                                                        </th>
                                                        <th className="sort" data-sort="class_id">Id. turma</th>
                                                        <th className="sort" data-sort="class_number">Número da turma</th>
                                                        <th className="sort" data-sort="course_id">Nome do curso</th>
                                                        <th className="sort" data-sort="vacancy">Vagas</th>
                                                        <th className="sort" data-sort="dt_start">Data início</th>
                                                        <th className="sort" data-sort="dt_end">Data fim</th>
                                                        <th className="sort" data-sort="client_id">Regional</th>
                                                        <th className="sort" data-sort="workload">Carga horária</th>
                                                        <th className="sort" data-sort="class_modality_id">Modalidade</th>
                                                        <th className="sort" data-sort="_created_at">Criado em</th>
                                                        <th className="sort" data-sort="class_status_id">Status da turma</th>
                                                        <th className="sort" data-sort="city_id">Realizado em</th>

                                                    </tr>
                                                </thead>
                                                <tbody className="list form-check-all" ref={containerRef}>
                                                    {!listData.length ? <>
                                                        <tr>
                                                            <td colSpan="14">
                                                                <div className="noresult">
                                                                    <div className="text-center">
                                                                        <lord-icon src="https://cdn.lordicon.com/msoeawqm.json"
                                                                            trigger="loop" colors="primary:#121331,secondary:#08a88a" style={{ width: '75px', height: '75px' }}></lord-icon>
                                                                        <h5 className="mt-2">Sinto muito! Não há resultados.</h5>
                                                                        <p className="text-muted mb-0">Não encontramos nenhum registro em nosso banco de dados.</p>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </> :
                                                        (
                                                            listData.map(el => (

                                                                <tr key={el.class_id}>
                                                                    <th scope="row">
                                                                        <div className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={checkboxValues.includes(el.class_id)} name="chk_child" value={el.class_id} onChange={handleCheckboxChange} />
                                                                        </div>
                                                                    </th>
                                                                    <td nowrap="nowrap">{el.class_id}</td>
                                                                    <td nowrap="nowrap">{el.class_number}</td>
                                                                    <td nowrap="nowrap">{el.course_name}</td>
                                                                    <td nowrap="nowrap">{el.vacancy}</td>
                                                                    <td nowrap="nowrap">{SingMask.toDate(el.dt_start, "dmY")}</td>
                                                                    <td nowrap="nowrap">{SingMask.toDate(el.dt_end, "dmY")}</td>
                                                                    <td nowrap="nowrap">{el.client_name}</td>
                                                                    <td nowrap="nowrap">{el.workload}</td>
                                                                    <td nowrap="nowrap">{el.class_modality_name}</td>
                                                                    <td nowrap="nowrap">{SingMask.toDate(el._created_at, "dmYHi")}</td>
                                                                    <td nowrap="nowrap">{el.class_status_name}</td>
                                                                    <td nowrap="nowrap">{el.city_name}</td>
                                                                    <td nowrap="nowrap">
                                                                        <div className="dropdown d-inline-block">
                                                                            <button className="btn btn-soft-secondary btn-sm dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                <i className="ri-more-fill align-middle"></i>
                                                                            </button>
                                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                                {/* <li><a href="#!" className="dropdown-item"><i className="ri-eye-fill align-bottom me-2 text-muted"></i> View</a></li> */}
                                                                                <li>
                                                                                    <Link to={`/admin/register/subscriber/${el.class_id}`} state={{ stateData: el }} title="" className="dropdown-item" data-filter-tags="application intel marketing dashboard">
                                                                                    <i className="ri-search-line search-icon align-bottom me-2 text-muted"></i> Listar inscritos
                                                                                    </Link>
                                                                                </li>
                                                                                <li>
                                                                                    <Link to={`/admin/register/class/${el.class_id}`} state={{ stateData: el }} title="" className="dropdown-item edit-item-btn" data-filter-tags="application intel marketing dashboard">
                                                                                        <i className="ri-pencil-fill align-bottom me-2 text-muted"></i> Editar turma
                                                                                    </Link>
                                                                                </li>
                                                                                <li>
                                                                                    <SweetButton props={{
                                                                                        button: {
                                                                                            className: "dropdown-item remove-item-btn",
                                                                                            icon: "ri-delete-bin-fill align-bottom me-2 text-muted",
                                                                                            text: "Excluir"
                                                                                        },
                                                                                        swlConfig: {
                                                                                            type: "dialog",
                                                                                            icon: "question",
                                                                                            title: "Deseja excluir",
                                                                                            text: `Cód. ${el.class_id} - ${el.course_name}?`,
                                                                                            confirmButtonText: "Sim, excluir mesmo assim.",
                                                                                            confirmButtonColor: '#d33', // Altere para a cor desejada em hexadecimal
                                                                                        },
                                                                                        actions: {
                                                                                            IfConfirmed: () => handlerDelete(el.class_id), // Passar como uma função
                                                                                            IfDenied: ""
                                                                                        }
                                                                                    }} />
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )))
                                                    }
                                                </tbody>

                                                <tfoot>
                                                    <tr>
                                                        <th></th>
                                                        <th className="sort" data-sort="class_id">Id. turma</th>
                                                        <th className="sort" data-sort="class_number">Número da turma</th>
                                                        <th className="sort" data-sort="course_id">Nome do curso</th>
                                                        <th className="sort" data-sort="vacancy">Vagas</th>
                                                        <th className="sort" data-sort="dt_start">Data início</th>
                                                        <th className="sort" data-sort="dt_end">Data fim</th>
                                                        <th className="sort" data-sort="client_id">Regional</th>
                                                        <th className="sort" data-sort="workload">Carga horária</th>
                                                        <th className="sort" data-sort="class_modality_id">Modalidade</th>
                                                        <th className="sort" data-sort="_created_at">Criado em</th>
                                                        <th className="sort" data-sort="class_status_id">Status da turma</th>
                                                        <th className="sort" data-sort="city_id">Realizado em</th>

                                                    </tr>
                                                </tfoot>
                                            </table>


                                        </div>

                                        <div className="d-flex justify-content-end">
                                            <div className="pagination-wrap hstack gap-2">
                                                {isShow_paginator &&
                                                    <Paginator template={template1} first={first[0]} rows={rows[0]} totalRecords={getTotalRecords} onPageChange={(e) => onPageChange(e, 0)} /* leftContent={leftContent} */ /* rightContent={rightContent} */ />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                    </div>

                </div>

            </div>

            <ShowToast resume={onResume}></ShowToast>
        </>
    );
})

export default FragmentList;

